import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation('notfound');

  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center bg-white px-4">
      <div data-testid="not-found-content" className="text-center">
        <h1 data-testid="not-found-title" className="text-7xl sm:text-9xl font-bold text-[#4ABDBD] mb-4 tracking-tight">
          {t('notfound.title')}
        </h1>
        <p data-testid="not-found-message" className="text-lg sm:text-xl text-gray-700 mb-8 max-w-md mx-auto">
          {t('notfound.message')}
        </p>
        <Link
          data-testid="back-to-home-link"
          to="/"
          className="inline-block px-6 py-3 bg-[#4ABDBD] text-white rounded-lg transition text-base sm:text-lg font-semibold hover:opacity-90"
        >
          {t('notfound.back_button')}
        </Link>
      </div>
    </div>
  );
}

export default NotFound;